module.exports = {"330324001":"东城街道","330324002":"北城街道","330324003":"南城街道","330324006":"三江街道","330324007":"黄田街道","330324008":"乌牛街道","330324009":"瓯北街道","330324102":"桥头镇","330324104":"桥下镇","330324105":"大若岩镇","330324106":"碧莲镇","330324107":"巽宅镇","330324108":"岩头镇","330324109":"枫林镇","330324110":"岩坦镇","330324111":"沙头镇","330324112":"鹤盛镇","330324113":"金溪镇","330324226":"云岭乡","330324227":"茗岙乡","330324228":"溪下乡","330324229":"界坑乡","330324400":"县特产场场区","330324401":"四海山林场","330324402":"正江山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330324.json
// module id = 1073
// module chunks = 0